import { render, staticRenderFns } from "./AdOverallRejectPanel.vue?vue&type=template&id=52012f96&scoped=true&"
import script from "./AdOverallRejectPanel.vue?vue&type=script&lang=js&"
export * from "./AdOverallRejectPanel.vue?vue&type=script&lang=js&"
import style0 from "./AdOverallRejectPanel.vue?vue&type=style&index=0&id=52012f96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52012f96",
  null
  
)

export default component.exports